enum BusinessType {
  NotSet = 0,
  PLC = 1,
  LTDCompany = 2,
  LLPPartnership = 3,
  SoleTraderSelfEmployed = 4
}

export default BusinessType;
